import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { TextField, Grid } from '@material-ui/core';
import { get } from 'lodash';
import { translate } from 'containers/services/translate';
import messages from 'containers/TransactionManagerTimeLine/OfferRegulation/messages';
import { Container } from 'containers/TransactionManagerTimeLine/VictimInfo/styles';

export interface BeneficiaryCardProps {
  intl: IntlShape;
  offerInfo: any;
  inputProps?: any;
}

const BeneficiaryCard: React.FC<BeneficiaryCardProps> = (
  props,
): JSX.Element => {
  return (
    <Container className="container">
      {get(props.offerInfo, 'nextOfKins', []).map((el: any) => (
        <section className="item-container">
          <article className="item">{get(el, 'fullName')}</article>
          <Grid container direction="row" spacing={2}>
            <Grid item xs={3} className="grid-input">
              <TextField
                type="number"
                label={translate(messages.offerIndemnityTitle, props)}
                className="input-4-1"
                InputProps={props.inputProps}
                disabled={true}
                value={get(el, 'totalAmounts')}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={3} className="grid-input">
              <TextField
                type="number"
                label={translate(messages.rate, props)}
                className="input-4-1"
                InputProps={props.inputProps}
                disabled={true}
                value={get(el, 'rate')}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={3} className="grid-input">
              <TextField
                type="number"
                label={translate(messages.prejudiceMoral, props)}
                className="input-4-1"
                InputProps={props.inputProps}
                disabled={true}
                value={get(el, 'prejMoral')}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={3} className="grid-input">
              <TextField
                type="number"
                label={translate(messages.prejudiceMaterial, props)}
                className="input-4-1"
                InputProps={props.inputProps}
                disabled={true}
                value={get(el, 'prejMateriel')}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          </Grid>
        </section>
      ))}
    </Container>
  );
};
export default injectIntl(BeneficiaryCard);
